<template>
  <div class="animated fadeIn">
    <b-modal  ref="modal-notificacao-coluna" centered button-size="sm" v-on:hide="hideModal" v-on:close="hideModal">
      <template #modal-title>
        <i class="fas fa-envelope"></i>&nbsp; NOTIFICAR USUÁRIO
      </template>
      <div class="col-md-12">
        <label for="txtGroup">
          Usuários que serão notificados:
        </label>
        <div class="input-group">
          <v-select multiple
                    v-model="form.usuarioList.value"
                    :options="form.usuarioList.options"
                    :reduce="option => option.value"
                    class="w-100"
                    label="text" placeholder="Selecione os Usuários">
            <template v-slot:no-options>Nenhum Usuário encontrado.</template>
          </v-select>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn rounded btn-third btn-sm" v-on:click="saveAndClose"> <i class="fa fa-check mr-1"></i> <span class="d-md-down-none">Salvar</span></button>&nbsp;
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { loading } from '@/shared/utils/UIHelper'
import AccountRepository from '@/shared/http/repositories/access/account.js'
import ModalNotificacaoForm from './ModalNotificacao-form'

const usuarioListNotificacao = {
  usuarioList: null
}
export default {
  name: 'ModalNotificacao',
  props: {
    column: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      isEditing: null,
      form: ModalNotificacaoForm,
      data: usuarioListNotificacao,
      boardColumn: null
    }
  },
  components: {},
  created () {},
  async mounted () {
    await this.onLoadAllAccount()
    await this.onLoadSelectedUser()
    this.showModal()
  },
  methods: {
    showModal () {
      this.$refs['modal-notificacao-coluna'].show()
    },
    hideModal () {
      this.$emit('Reload')
    },
    onEdit (obj) {
      this.isEditing = obj
    },
    saveAndClose () {
      this.boardColumn = this.column
      this.boardColumn.usuarioList = this.form.usuarioList.value
      this.$parent.boardColumns[this.index] = this.boardColumn
      this.$emit('update', this.boardColumn.usuarioList)
    },
    onLoadAllAccount () {
      loading.push()
      AccountRepository.GetAllName()
        .then((response) => {
          loading.pop()
          this.form.usuarioList.options = response.data.content.map(usuario => {
            return ({'text': usuario.nomePessoa, 'value': usuario.id})
          })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    onLoadSelectedUser () {
      this.form.usuarioList.value = this.column.usuarioList
    }
  }
}

</script>
<style lang="scss">
.formulate-input-element.formulate-input-element--textarea {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/notificacao-usuario/ModalNotificacao.vue